import React from 'react';
import PropTypes from 'prop-types';

import './ReviewsStatisticsHeader.scss';

const ReviewsStatisticsHeader = ({ selectedVenueName, selectedClassName, selectedInstructorName }) => (
  <div className="ratings-statistics-header" data-cypress="ratings-statistics-header">
    <p className="ratings-statistics-header__venue-name">{selectedVenueName}</p>
    <p className="ratings-statistics-header__class-name">{selectedClassName}</p>
    <p className="ratings-statistics-header__instructor-name">{selectedInstructorName}</p>
  </div>
);

ReviewsStatisticsHeader.propTypes = {
  selectedVenueName: PropTypes.string,
  selectedClassName: PropTypes.string,
  selectedInstructorName: PropTypes.string,
};

export default ReviewsStatisticsHeader;
